import { render, staticRenderFns } from "./upload-file.vue?vue&type=template&id=fe076904&scoped=true"
import script from "./upload-file.vue?vue&type=script&lang=ts"
export * from "./upload-file.vue?vue&type=script&lang=ts"
import style0 from "./upload-file.vue?vue&type=style&index=0&id=fe076904&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe076904",
  null
  
)

export default component.exports